const _TOLERANCE = 2

/**
 * A function to determine the track time based on the difference between local and remote track positions
 * @param currentTime The current local track position
 * @param syncedTime The remote track position to check
 * @param syncedTimestamp The timestamp of remote track position
 */
export default function (currentTime: number, syncedTime: number): number {

  if (syncedTime === null) return currentTime

  const timeAdjusted = syncedTime

  return (
    timeAdjusted > (currentTime - _TOLERANCE) &&
    timeAdjusted < (currentTime + _TOLERANCE)
  ) ? currentTime : timeAdjusted

}
